import { useEffect, useState } from 'react';

import MeasurementInsights from './components/MeasurementInsights';
import MeasurementCharts from './components/MeasurementCharts';
import MeasurementTable from './components/MeasurementTable';
import { getMeasurements } from '../../../api/reports.api';

export default function MeasurementsTab({ userId }) {
  const [measurements, setMeasurements] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log('measurements', measurements);
  const load = async () => {
    try {
      setLoading(true);

      const res = await getMeasurements(userId);
      const list = res.data.measurements || [];

      // مرتب‌سازی از قدیمی به جدید
      list.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      setMeasurements(list);
    } catch (err) {
      console.error('Load measurements error:', err);
    }

    setLoading(false);
  };

  useEffect(() => {
    load();
  }, [userId]);

  if (loading) return <p>در حال بارگذاری...</p>;
  if (!measurements.length)
    return <p className="text-gray-500">هنوز اندازه‌ای ثبت نشده است.</p>;

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold">سایزها</h2>

      {/* خلاصه پیشرفت */}
      <MeasurementInsights data={measurements} />

      {/* نمودارها */}
      <MeasurementCharts userId={userId} />

      {/* جدول تاریخچه */}
      <MeasurementTable data={measurements} />
    </div>
  );
}
